import { aiProcessRunsReducer } from './aiProcessRuns.reducer';

export default { aiProcessRuns: aiProcessRunsReducer };
